import { generate } from "rxjs";

export const unitList = [
  { id: "ml", name: "ml", type: "liters" },
  { id: "l", name: "liters", type: "liters" },
  { id: "gm", name: "gm", type: "gms" },
  { id: "kg", name: "kg", type: "gms" },
  { id: "piece", name: "piece", type: "piece" },
  { id: "pack", name: "pack", type: "pack" },
];

export const categoryTypeOptions = [
  { id: "main", name: "Main Category" },
  { id: "category", name: "Category" },
  { id: "sub", name: "Sub Category" },
];

export const categoryModelOptions = [
  { id: "product", name: "Product" },
  { id: "kitchen", name: "Prasadam" },
  { id: "package", name: "Package" },
  { id: "service", name: "Service" },
  { id: "comic", name: "Comic" },
  { id: "book", name: "Book" },
];

export const typeList = [
  {
    id: 0, name: "product-image", type: "Image", ratio: "1:1", maxSizeMB: 10
  },
  {
    id: 1, name: "product-thumbnail", type: "Image", ratio: "1:1", maxSizeMB: 5
  },
  {
    id: 2, name: "category-image", type: "Image", ratio: "1:1", maxSizeMB: 3
  },
  {
    id: 3, name: "carousel-image", type: "Image", ratio: "1:1", maxSizeMB: 5
  },
  {
    id: 4, name: "slider-image", type: "Image", ratio: "16:9", maxSizeMB: 5
  },
  {
    id: 5, name: "banner-image", type: "Image", ratio: "16:9", maxSizeMB: 5
  },
  {
    id: 6, name: "grid-image", type: "Image", ratio: "1:1", maxSizeMB: 5
  },
  {
    id: 7, name: "bar-image", type: "Image", ratio: "20:1", maxSizeMB: 3
  },
  { id: 8, name: "offer-animation-gif", type: "GIF", maxSizeMB: 12 },
  { id: 9, name: "offer-animation-mp4", type: "Video", maxSizeMB: 25 },
  { id: 10, name: "promotion-animation-gif", type: "GIF", maxSizeMB: 12 },
  { id: 11, name: "promotion-animation-mp4", type: "Video", maxSizeMB: 25 },
  { id: 12, name: "panchangam-calendar", type: "Document/Image" },
  { id: 13, name: "Document/Image", type: "Document/Image" },
  { id: 14, name: "comic-cover-image", type: "Image", ratio: "1:1", maxSizeMB: 5 },
  { id: 15, name: "comic-banner-image", type: "Image", ratio: "16:9", maxSizeMB: 5 },
  { id: 16, name: "comic-page-image", type: "Image", ratio: "9:16", maxSizeMB: 5 },
  { id: 17, name: "book-cover-image", type: "Image", ratio: "1:1", maxSizeMB: 5 },
  { id: 18, name: "book-pdf", type: "Document", maxSizeMB: 25 },
  { id: 19, name: "stotram-audio-mp3", type: "Audio", maxSizeMB: 25 },
];

export const OFFERSLIST = [
  {
    "page": "home",
    "section": "section1",
    "title": "NA",
  },
  {
    "page": "home",
    "section": "section2",
    "title": "NA",
  },
  {
    "page": "home",
    "section": "section3",
    "title": "NA",
  },
  {
    "page": "home",
    "section": "section4",
    "title": "NA",
  },

  {
    "page": "home",
    "section": "section5",
    "title": "NA",
  },
  {
    "page": "home",
    "section": "section6",
    "title": "NA",
  },
  {
    "page": "cart",
    "section": "section1",
    "title": "NA",
  },
  {
    "page": "category",
    "section": "section1",
    "title": "NA",
  },
  {
    "page": "monthly",
    "section": "section1",
    "title": "NA",
  },
  {
    "page": "monthlydetail",
    "section": "section1",
    "title": "NA",
  },
  {
    "page": "search",
    "section": "section1",
    "title": "NA",
  },
  {
    "page": "kitchen",
    "section": "section1",
    "title": "NA",
  },
]

export const CITY_OFFERSLIST = [
  {
    "page": "spiritualjourney",
    "section": "section1",
    "title": "NA",
  },
  {
    "page": "temple",
    "section": "section1",
    "title": "NA",
  },
  {
    "page": "templedetail",
    "section": "section1",
    "title": "NA",
  },
  {
    "page": "templeevent",
    "section": "section1",
    "title": "NA",
  },
  {
    "page": "templeeventdetail",
    "section": "section1",
    "title": "NA",
  },
  {
    "page": "events",
    "section": "section1",
    "title": "NA",
  },
  {
    "page": "events",
    "section": "section2",
    "title": "NA",
  },
  {
    "page": "eventdetail",
    "section": "section1",
    "title": "NA",
  },
  {
    "page": "libraryhome",
    "section": "section1",
    "title": "NA",
  },
  {
    "page": "comics",
    "section": "section1",
    "title": "NA",
  },
  {
    "page": "books",
    "section": "section1",
    "title": "NA",
  },
]

export const offerType = [
  { id: 1, name: "carousel" },
  { id: 2, name: "slider" },
  { id: 3, name: "banner" },
  { id: 4, name: "grid" },
  { id: 5, name: "bar" }];

export const offerSelectionType = [
  {
    id: 1, name: 'Tags'
  },
  {
    id: 2, name: 'Product'
  }
]

export const STATS_DATE_OPTIONS = [
  "Today",
  "Yesterday",
  "This Week",
  "Last Week",
  "Current Month",
  "Last Month"
];


export const pageList = [
  { _id: "home", name: "home" },
  { _id: "categories", name: "categories" },
  { _id: "cart", name: "cart" },
  { _id: "monthlypass", name: "package" },
  { _id: "productlist", name: "productlist" },
  { _id: "productdetails", name: "productdetails" },
  { _id: "events", name: "events" },
  { _id: "eventdetail", name: "eventdetail" },
  { _id: "eventcart", name: "eventcart" },
  { _id: "spiritualjourney", name: "spiritualjourney" },
  { _id: "temple", name: "temple" },
  { _id: "templeevent", name: "templeevent" },
  { _id: "templecart", name: "templecart" }
];

export const imageUploadConst = {
  copyLinkLabel: 'Copy',
  copyLinkAfterCopy: 'Copied',
  copyClass: 'copy text-danger cursor-pointer',
  copyClassAfterCopy: 'copy text-success'
}

export const PAGES = [
  { _id: 'home', name: "Home" },
  { _id: 'cart', name: "Cart" },
  { _id: 'kitchen', name: "Prasadam" },
  { _id: 'search', name: "Search" },
  { _id: 'events', name: "Events" },
  { _id: 'eventdetail', name: "Event Detail" },
  { _id: 'eventcart', name: "Event Cart" },
  { _id: 'spiritualjourney', name: "Spiritual Journey" },
  { _id: 'temple', name: "Temple Detail" },
  { _id: 'templeevent', name: "Temple Event Detail" },
  { _id: 'templecart', name: "Temple Cart" },

]

export const PAYMENTLIST = [
  { name: 'Cash On Delivery', _id: 'COD' },
  { name: 'Payment Gateway', _id: 'PG', isDisabled: true }
]

export const menuConfig = [
  {
    title: 'Dashboard',
    icon: 'la la-file',
    page: '/dashboard',
    module: 'dashboardManagement',
    pageType: 'view'
  },
  {
    title: 'Panchangam Calendar',
    icon: 'fa fa-calendar',
    page: '/panchangam-calendar',
    module: 'dashboardManagement',
    pageType: 'view'
  },
  {
    title: 'Product Management',
    icon: 'la la-list',
    page: 'null',
    module: 'productManagement',
    submenu: {
      items: [
        {
          title: 'Product List',
          page: '/product/all',
          module: 'productManagement',
          pageType: 'view'
        },
        {
          title: 'Add Product',
          page: '/product/create',
          module: 'productManagement',
          pageType: 'add'
        },
        {
          title: 'Inhouse Products',
          page: '/rakeemart-product/all',
          module: 'productManagement',
          pageType: 'view'
        },
      ]
    }
  },
  {
    title: 'Category Management',
    icon: 'la la-support',
    page: 'null',
    module: 'categoryManagement',
    submenu: {
      items: [
        {
          title: 'Category List',
          page: '/category/all',
          module: 'categoryManagement',
          pageType: 'view'
        },
        {
          title: 'Add Category',
          page: '/category/create',
          module: 'categoryManagement',
          pageType: 'add'
        },
      ]
    }
  },
  {
    title: 'Offer Management',
    icon: 'la la-television',
    page: 'null',
    module: 'offerManagement',
    submenu: {
      items: [
        {
          title: 'Offer List',
          page: '/offer/all',
          module: 'offerManagement',
          pageType: 'view'
        },
        {
          title: 'Offer Section',
          page: '/offer/section',
          module: 'offerManagement',
          pageType: 'view'
        },
        {
          title: 'Add Offer',
          page: '/offer/create',
          module: 'offerManagement',
          pageType: 'add'
        },
      ]
    }
  },
  {
    title: 'Zone & Location Management',
    icon: 'fa fa-area-chart',
    page: 'null',
    module: 'zoneManagement',
    submenu: {
      items: [
        {
          title: 'Zone List',
          page: '/zone/all',
          module: 'zoneManagement',
          pageType: 'view'
        },
        {
          title: 'Add Zone',
          page: '/zone/create',
          module: 'zoneManagement',
          pageType: 'add'
        },
        {
          title: 'State List',
          page: '/zone/states/all',
          module: 'zoneManagement',
          pageType: 'view'
        },
        {
          title: 'Add State',
          page: '/zone/states/create',
          module: 'zoneManagement',
          pageType: 'add'
        },
        {
          title: 'Region List',
          page: '/zone/regions/all',
          module: 'zoneManagement',
          pageType: 'view'
        },
        {
          title: 'Add Region',
          page: '/zone/regions/create',
          module: 'zoneManagement',
          pageType: 'add'
        },
        {
          title: 'District List',
          page: '/zone/districts/all',
          module: 'zoneManagement',
          pageType: 'view'
        },
        {
          title: 'Add District',
          page: '/zone/districts/create',
          module: 'zoneManagement',
          pageType: 'add'
        },
        {
          title: 'City List',
          page: '/zone/cities/all',
          module: 'zoneManagement',
          pageType: 'view'
        },
        {
          title: 'Add City',
          page: '/zone/cities/create',
          module: 'zoneManagement',
          pageType: 'add'
        },
        {
          title: 'Area List',
          page: '/zone/areas/all',
          module: 'zoneManagement',
          pageType: 'view'
        },
        {
          title: 'Add Area',
          page: '/zone/areas/create',
          module: 'zoneManagement',
          pageType: 'add'
        },
      ]
    }
  },
  {
    title: 'Retailer Management',
    icon: 'la la-shopping-cart',
    page: 'null',
    module: 'retailerManagement',
    submenu: {
      items: [
        {
          title: 'Retailer List',
          page: '/retailer/all',
          module: 'retailerManagement',
          pageType: 'view'
        },
        {
          title: 'Add Retailer',
          page: '/retailer/create',
          module: 'retailerManagement',
          pageType: 'add'
        },
        {
          title: 'Reatiler Orders',
          page: '/retailer/orders',
          module: 'retailerManagement',
          pageType: 'add'
        },

      ]
    }
  },
  {
    title: 'Supplier Management',
    icon: 'fa fa-truck',
    page: 'null',
    module: 'supplierManagement',
    submenu: {
      items: [
        {
          title: 'Suppliers',
          page: '/supplier/all',
          module: 'supplierManagement',
          pageType: 'view'
        },
        {
          title: 'Add Supplier',
          page: '/supplier/create',
          module: 'supplierManagement',
          pageType: 'add'
        },
        {
          title: 'Agreements',
          page: '/supplier-agreements/all',
          module: 'supplierAgreementManagement',
          pageType: 'view'
        },
        {
          title: 'Add Agreement',
          page: '/supplier-agreements/create',
          module: 'supplierAgreementManagement',
          pageType: 'add'
        },
        {
          title: 'Supplier Orders',
          page: '/supplier-orders/all',
          module: 'supplierOrderManagement',
          pageType: 'view'
        },
        {
          title: 'Supplier Invoices',
          page: '/supplier-invoices/all',
          module: 'supplierInvoiceManagement',
          pageType: 'view'
        },
        {
          title: 'Credit Notes',
          page: '/supplier-credit-notes/all',
          module: 'supplierCreditNoteManagement',
          pageType: 'view'
        },
        {
          title: 'Settlements',
          page: '/supplier-settlements/all',
          module: 'supplierSettlementManagement',
          pageType: 'view'
        },
      ]
    }
  },
  {
    title: 'Package',
    icon: 'la la-file-text',
    page: 'null',
    module: 'monthlypassManagement',
    submenu: {
      items: [
        {
          title: 'Package List',
          page: '/monthlypass/all',
          module: 'monthlypassManagement',
          pageType: 'view'
        },
        {
          title: 'Add Package',
          page: '/monthlypass/create',
          module: 'monthlypassManagement',
          pageType: 'add'
        },
      ]
    }
  },
  {
    title: 'Product Promotion',
    icon: 'la la-sitemap',
    page: 'null',
    module: 'productPromotionsManagement',
    submenu: {
      items: [
        {
          title: 'Promotion List',
          page: '/product-promotion/all',
          module: 'productPromotionsManagement',
          pageType: 'view'
        },
        {
          title: 'Add Product Promotion',
          page: '/product-promotion/create',
          module: 'productPromotionsManagement',
          pageType: 'add'
        },
      ]
    }
  },
  {
    title: 'Delivery Agent',
    icon: 'la la-taxi',
    page: 'null',
    module: 'deliveryManagement',
    submenu: {
      items: [
        {
          title: 'Delivery Agent List',
          page: '/delivery-agent/all',
          module: 'deliveryManagement',
          pageType: 'view'
        },
        {
          title: 'Add Delivery Agent',
          page: '/delivery-agent/create',
          module: 'deliveryManagement',
          pageType: 'add'
        },
      ]
    }
  },
  {
    title: 'User Representative',
    icon: 'fa fa-address-card',
    page: 'null',
    module: 'userRepManagement',
    submenu: {
      items: [
        {
          title: 'User Representative List',
          page: '/user-representative/all',
          module: 'userRepManagement',
          pageType: 'view'
        },
        {
          title: 'Add User Representative',
          page: '/user-representative/create',
          module: 'userRepManagement',
          pageType: 'add'
        },
      ]
    }
  },
  {
    title: 'Service Providers',
    icon: 'fa fa-briefcase',
    page: 'null',
    module: 'serviceProviderManagement',
    submenu: {
      items: [
        {
          title: 'Service Provider List',
          page: '/service-provider/all',
          module: 'serviceProviderManagement',
          pageType: 'view'
        },
        {
          title: 'Add Service Provider',
          page: '/service-provider/create',
          module: 'serviceProviderManagement',
          pageType: 'add'
        },
        {
          title: 'Service Bookings',
          page: '/service-booking/all',
          module: 'serviceProviderManagement',
          pageType: 'view'
        },
      ]
    }
  },
  {
    title: 'Services',
    icon: 'fa fa-wrench',
    page: 'null',
    module: 'serviceManagement',
    submenu: {
      items: [
        {
          title: 'Services List',
          page: '/service/all',
          module: 'serviceManagement',
          pageType: 'view'
        },
        {
          title: 'Add Service',
          page: '/service/create',
          module: 'serviceManagement',
          pageType: 'add'
        },
      ]
    }
  },
  {
    title: 'Devotional Library',
    icon: 'fa fa-book',
    page: 'null',
    module: 'devotionalLibraryManagement',
    submenu: {
      items: [
        {
          title: 'Library Overview',
          page: '/devotional-library/dashboard',
          module: 'devotionalLibraryManagement',
          pageType: 'view'
        },
        {
          title: 'Comic Series',
          page: '/devotional-library/comics/all',
          module: 'devotionalLibraryManagement',
          pageType: 'view'
        },
        {
          title: 'Add Comic Series',
          page: '/devotional-library/comics/create',
          module: 'devotionalLibraryManagement',
          pageType: 'add'
        },
        {
          title: 'Books',
          page: '/devotional-library/books/all',
          module: 'devotionalLibraryManagement',
          pageType: 'view'
        },
        {
          title: 'Add Book',
          page: '/devotional-library/books/create',
          module: 'devotionalLibraryManagement',
          pageType: 'add'
        },
        {
          title: 'Stotrams',
          page: '/devotional-library/stotrams/all',
          module: 'devotionalLibraryManagement',
          pageType: 'view'
        },
        {
          title: 'Add Stotram',
          page: '/devotional-library/stotrams/create',
          module: 'devotionalLibraryManagement',
          pageType: 'add'
        },
        {
          title: 'Deity Groups',
          page: '/devotional-library/deity-groups/all',
          module: 'devotionalLibraryManagement',
          pageType: 'view'
        },
        {
          title: 'Add Deity Group',
          page: '/devotional-library/deity-groups/create',
          module: 'devotionalLibraryManagement',
          pageType: 'add'
        },
      ]
    }
  },
  {
    title: 'Devotional Events',
    icon: 'fa fa-calendar-check-o',
    page: 'null',
    module: 'devotionalEventManagement',
    submenu: {
      items: [
        {
          title: 'Events Overview',
          page: '/devotional-events/dashboard',
          module: 'devotionalEventManagement',
          pageType: 'view'
        },
        {
          title: 'Event Types',
          page: '/devotional-events/types/all',
          module: 'devotionalEventManagement',
          pageType: 'view'
        },
        {
          title: 'Add Event Type',
          page: '/devotional-events/types/create',
          module: 'devotionalEventManagement',
          pageType: 'add'
        },
        {
          title: 'Organizers',
          page: '/devotional-events/organizers/all',
          module: 'devotionalEventManagement',
          pageType: 'view'
        },
        {
          title: 'Add Organizer',
          page: '/devotional-events/organizers/create',
          module: 'devotionalEventManagement',
          pageType: 'add'
        },
        {
          title: 'Ticket Validators',
          page: '/devotional-events/validators/all',
          module: 'devotionalEventManagement',
          pageType: 'view'
        },
        {
          title: 'Add Ticket Validator',
          page: '/devotional-events/validators/create',
          module: 'devotionalEventManagement',
          pageType: 'add'
        },
        {
          title: 'Events',
          page: '/devotional-events/all',
          module: 'devotionalEventManagement',
          pageType: 'view'
        },
        {
          title: 'Bookings',
          page: '/devotional-events/bookings/all',
          module: 'devotionalEventManagement',
          pageType: 'view'
        },
        {
          title: 'Invoices',
          page: '/devotional-events/invoices/all',
          module: 'devotionalEventManagement',
          pageType: 'view'
        },
      ]
    }
  },
  {
    title: 'Temple Management',
    icon: 'fa fa-university',
    page: 'null',
    module: 'templeManagement',
    submenu: {
      items: [
        {
          title: 'Temple Overview',
          page: '/temple/dashboard',
          module: 'templeManagement',
          pageType: 'view'
        },
        {
          title: 'Temples',
          page: '/temples/all',
          module: 'templeManagement',
          pageType: 'view'
        },
        {
          title: 'Add Temple',
          page: '/temples/create',
          module: 'templeManagement',
          pageType: 'add'
        },
        {
          title: 'Temple Poojas',
          page: '/temple-poojas/all',
          module: 'templePoojaManagement',
          pageType: 'view'
        },
        {
          title: 'Temple Events',
          page: '/temple-events/all',
          module: 'templeEventManagement',
          pageType: 'view'
        },
        {
          title: 'Temple Bookings',
          page: '/temple-bookings/all',
          module: 'templeBookingManagement',
          pageType: 'view'
        },
        {
          title: 'Generate Pooja Ticket',
          page: '/temple-bookings/offline/create',
          module: 'templeBookingManagement',
          pageType: 'add'
        },
        {
          title: 'Temple Tickets',
          page: '/temple-tickets/all',
          module: 'templeTicketManagement',
          pageType: 'view'
        },
      ]
    }
  },
  {
    title: 'Subscriptions',
    icon: 'fa fa-id-card',
    page: 'null',
    module: 'subscriptionManagement',
    submenu: {
      items: [
        {
          title: 'Subscription Overview',
          page: '/subscriptions/dashboard',
          module: 'subscriptionManagement',
          pageType: 'view'
        },
        {
          title: 'Tiers',
          page: '/subscriptions/tiers/all',
          module: 'subscriptionManagement',
          pageType: 'view'
        },
        {
          title: 'Add Tier',
          page: '/subscriptions/tiers/create',
          module: 'subscriptionManagement',
          pageType: 'add'
        },
        {
          title: 'Plans',
          page: '/subscriptions/plans/all',
          module: 'subscriptionManagement',
          pageType: 'view'
        },
        {
          title: 'Add Plan',
          page: '/subscriptions/plans/create',
          module: 'subscriptionManagement',
          pageType: 'add'
        },
        {
          title: 'Benefit Rules',
          page: '/subscriptions/benefit-rules/all',
          module: 'subscriptionManagement',
          pageType: 'view'
        },
        {
          title: 'Add Benefit Rule',
          page: '/subscriptions/benefit-rules/create',
          module: 'subscriptionManagement',
          pageType: 'add'
        },
        {
          title: 'User Subscriptions',
          page: '/subscriptions/users/all',
          module: 'subscriptionManagement',
          pageType: 'view'
        },
      ]
    }
  },
  {
    title: 'Temple Workspace',
    icon: 'fa fa-university',
    page: 'null',
    module: 'templeAdminProfileManagement',
    submenu: {
      items: [
        {
          title: 'My Temple',
          page: '/templeadmin/profile',
          module: 'templeAdminProfileManagement',
          pageType: 'view'
        },
        {
          title: 'My Poojas',
          page: '/templeadmin/poojas/all',
          module: 'templeAdminPoojaManagement',
          pageType: 'view'
        },
        {
          title: 'Create Pooja',
          page: '/templeadmin/poojas/create',
          module: 'templeAdminPoojaManagement',
          pageType: 'add'
        },
        {
          title: 'My Events',
          page: '/templeadmin/events/all',
          module: 'templeAdminEventManagement',
          pageType: 'view'
        },
        {
          title: 'Create Event',
          page: '/templeadmin/events/create',
          module: 'templeAdminEventManagement',
          pageType: 'add'
        },
        {
          title: 'Ticket Validators',
          page: '/templeadmin/validators/all',
          module: 'templeAdminTicketValidatorManagement',
          pageType: 'view'
        },
        {
          title: 'My Bookings',
          page: '/templeadmin/bookings/all',
          module: 'templeAdminBookingManagement',
          pageType: 'view'
        },
        {
          title: 'Generate Pooja Ticket',
          page: '/templeadmin/bookings/offline/create',
          module: 'templeAdminBookingManagement',
          pageType: 'add'
        },
        {
          title: 'My Tickets',
          page: '/templeadmin/tickets/all',
          module: 'templeAdminTicketManagement',
          pageType: 'view'
        },
      ]
    }
  },
  {
    title: 'Organizer Workspace',
    icon: 'fa fa-bullhorn',
    page: 'null',
    module: 'eventOrganizerEventManagement',
    submenu: {
      items: [
        {
          title: 'My Profile',
          page: '/eventadmin/profile',
          module: 'eventOrganizerProfileManagement',
          pageType: 'view'
        },
        {
          title: 'My Events',
          page: '/eventadmin/events/all',
          module: 'eventOrganizerEventManagement',
          pageType: 'view'
        },
        {
          title: 'Create Event',
          page: '/eventadmin/events/create',
          module: 'eventOrganizerEventManagement',
          pageType: 'add'
        },
        {
          title: 'Ticket Validators',
          page: '/eventadmin/validators/all',
          module: 'eventOrganizerTicketValidatorManagement',
          pageType: 'view'
        },
        {
          title: 'My Bookings',
          page: '/eventadmin/bookings/all',
          module: 'eventOrganizerBookingManagement',
          pageType: 'view'
        },
        {
          title: 'My Invoices',
          page: '/eventadmin/invoices/all',
          module: 'eventOrganizerEventManagement',
          pageType: 'view'
        },
      ]
    }
  },
  {
    title: 'Telecaller',
    icon: 'fa fa-commenting',
    page: 'null',
    module: 'telecallerManagement',
    submenu: {
      items: [
        {
          title: 'Telecaller List',
          page: '/telecaller/all',
          module: 'telecallerManagement',
          pageType: 'view'
        },
        {
          title: 'Add Telecaller User',
          page: '/telecaller/create',
          module: 'telecallerManagement',
          pageType: 'add'
        },
      ]
    }
  },
  {
    title: 'Coupon Management',
    icon: 'fa fa-gift',
    page: 'null',
    module: 'couponManagement',
    submenu: {
      items: [
        {
          title: 'Coupon List',
          page: '/coupons/all',
          module: 'couponManagement',
          pageType: 'view'
        },
        {
          title: 'Add Coupon',
          page: '/coupon/create',
          module: 'couponManagement',
          pageType: 'add'
        },
      ]
    }
  },
  {
    title: 'Fee Management',
    icon: 'fa fa-money',
    page: 'null',
    module: 'feeManagement',
    submenu: {
      items: [
        {
          title: 'Fee List',
          page: '/fee/all',
          module: 'feeManagement',
          pageType: 'view'
        },
        {
          title: 'Add Fee',
          page: '/fee/create',
          module: 'feeManagement',
          pageType: 'add'
        },
      ]
    }
  },
  {
    title: 'Incentive Management',
    icon: 'fa fa-trophy',
    page: 'null',
    module: 'incentiveManagement',
    submenu: {
      items: [
        {
          title: 'Incentiverule List',
          page: '/incentive-rule/all',
          module: 'incentiveManagement',
          pageType: 'view'
        },
        {
          title: 'Add Incentiverule',
          page: '/incentive-rule/create',
          module: 'incentiveManagement',
          pageType: 'add'
        },
      ]
    }
  },
  {
    title: 'Order List',
    page: '/order/all',
    icon: 'la la-reorder',
    module: 'orderManagement',
    pageType: 'view'
  },
  {
    title: 'Payment List',
    page: '/payment/all',
    icon: 'la la-clipboard',
    module: 'paymentManagement',
    pageType: 'view'
  },
  {
    title: 'Users',
    icon: 'la la-user',
    page: '/users',
    module: 'userManagement',
    pageType: 'view'
  },
  {
    title: 'Bulk Upload',
    icon: 'la la-upload',
    page: '/bulk-upload',
    module: 'userManagement',
    pageType: 'view'
  }
  // { section: 'SUPPORT', icon: 'la la-ellipsis-h' },
  // {
  //   title: 'Raise Support',
  //   icon: 'la la-support',
  //   page: 'https://pixinvent.ticksy.com/',
  //   isExternalLink: true
  // },
  // {
  //   title: 'Documentaion',
  //   icon: 'la la-text-height',
  //   page: 'https://modern-admin-docs.web.app/html/ltr/documentation/index.html',
  //   isExternalLink: true,
  // }
]

export const appLinks = {
  authLogin: "/auth/login",
  authRefreshToken: "/verify/refresh-token",
  authVerifyPhoneNumber: "/verify/verify-phone-admin",
  authVerifyPhoneWithOTP: "/verify/verify-phone-check-admin",
  authVerifyPhoneEventAdmin: "/verify/verify-phone-eventadmin",
  authVerifyPhoneWithOTPEventAdmin: "/verify/verify-phone-check-eventadmin",
  authVerifyPhoneTempleAdmin: "/verify/verify-phone-templeadmin",
  authVerifyPhoneWithOTPTempleAdmin: "/verify/verify-phone-check-templeadmin",
  authVerifyPhoneResendOTP: "/verify/resend-otp",

  // Image upload
  imageUploadAPIHost: "/admin/upload-s",

  // product info
  getProductsListAPIHost: "/admin/products",
  getProductAPIHost: "/admin/products",
  getProductByIdAPIHost: "/admin/products",
  addProductAPIHost: "/admin/add-product",
  updateProductAPIHost: "/admin/edit-product",
  updateProductZoneLink: "/admin/edit-productzone",
  deleteProductAPIHost: "/admin/delete-product",
  // getProductBySubCategoryAPIHost: '/admin/products-by-subcat?subCategory=',
  getProductBySubCategoryAPIHost: "/admin/products-by-subcat",
  getAdminProductBySubCategoryAPIHost: "/admin/adminproducts-by-subcat",
  getProductFilter: "/admin/products-filters",
  getProductsByTagAPI: "/admin/products-by-tag",

  // RKMRT apis
  getRKMRTProductsAPIHost: "/admin/rkmrtproducts",
  addRKMRTProductAPIHost: "/admin/add-rkmrtproduct",
  generateRKMRTProductAPIHost: "/admin/generate-rkmrt-barcode",
  getRKMRTProductByBarcodeAPIHost: "/admin/rkmrtproductById",
  updateRKMRTProductAPIHost: "/admin/edit-rkmrtproduct",
  getRKMRTProductFilter: "/admin/rkmrtproducts-filters",
  getRKMRTProductTableListAPIHost: "/admin/rkmrtproducts-table",

  // tags
  getTagsListAPIHost: "/admin/tags",
  postTagsListAPIHost: "/admin/add-tag",
  updateTagAPIHost: "/admin/tags",
  deleteTagAPIHost: "/admin/tags",

  // Zones
  getZoneListAPI: "/admin/zones",
  addZoneAdminAPI: "/admin/add-zone",
  getZoneTableListLink: "/admin/zones",
  getZoneByIdLink: "/admin/zones",
  updateZoneAPI: "/admin/edit-zone",
  getZoneFiltersAPI: "/admin/zone-filters",
  deleteZoneAPI: "/admin/delete-zone",  statesListAPI: "/admin/states",
  statesAPI: "/admin/states",
  regionsListAPI: "/admin/regions",
  regionsAPI: "/admin/regions",
  districtsListAPI: "/admin/districts",
  districtsAPI: "/admin/districts",
  citiesListAPI: "/admin/cities",
  citiesAPI: "/admin/cities",
  areasListAPI: "/admin/areas",
  areasAPI: "/admin/areas",

  // brands
  getBrandsListAPIHost: "/admin/brands",
  postBrandListAPIHost: "/admin/add-brand",
  deleteBrandListAPIHost: "/admin/delete-brand",

  // Category info
  getAllCategoryListAPIHost: "/admin/categories",
  getMainCategoryListAPIHost: "/admin/categories-main",
  getKitchenMainCategoryAPIHost: "/admin/kitchen-main-category",
  getCategoryListAPIHost: "/admin/categories-category",
  getCategoryFilter: "/admin/category-filters",
  deleteCategoryAPIHost: "/admin/delete-category",
  getCategoryById: "/admin/categories",
  getSubCategoryListAPIHost: "/admin/categories-sub",
  addCategoryAPIHost: "/admin/add-category",
  updateCategoryAPIHost: "/admin/edit-category",
  getCategoryByModel: "/admin/categories-model",

  // Offers Info
  addOfferAPIHost: "/admin/add-offer",
  getOffersAPIHost: "/admin/offers",
  getOffersFilterAPI: "/admin/offer-filters",
  getOfferByGroupAPIHost: "/admin/offers-by-group/",
  editOffersAPIHost: "/admin/edit-offer",
  deleteOfferAPIHost: "/admin/delete-offer",
  getOfferSectionAPI: "/admin/offersections",
  editOfferSectionAPI: "/admin/set-section",
  clearOfferSectionAPI: "/admin/clear-section",
  postOfferSectionGroupIdAPI: "/admin/offersections-page",

  // MonthlyPack
  addMonthPackAPIHost: "/admin/add-monthlypack",
  getMonthPackAPIHost: "/admin/monthlypacks",
  deleteMonthlyPackAPIHost: "/admin/delete-monthlypack",
  getMonthlyPackByIdAPIHost: "/admin/monthlypack/",
  editMonthlyPackAPI: "/admin/edit-monthlypack",
  getMonthlyPackFiltersAPI: "/admin/monthlypack-filters",

  addRetailerAPI: "/admin/add-retailer",
  editRetailerAPI: "/admin/edit-retailer",
  getRetailerAPI: "/admin/retailers",
  getRetailerFilterAPI: "/admin/retailer-filters",
  getRetailerById: "/admin/retailers",
  deleteRetailerAPI: "/admin/delete-retailer",

  // Product Promotion

  getProductPromotionTableLink: "/admin/prdt-promtns",
  getProductPromotionFilterLink: "/admin/prodtpromtn-filters",
  addProductPromotionLink: "/admin/add-prodtpromtn",
  updateProductPromotionLink: "/admin/edit-prdtpromtn",
  deleteProductPromotionLink: "/admin/delete-prdtpromtn",
  getProductPromotionLInk: "/admin/prodtpromtn",

  // Delivery Agent
  addDeliveryAgentLink: "/admin/add-deliveryagent",
  editDeliveryAgentLink: "/admin/edit-deliveryagent",
  getDeliveryAgentLink: "/admin/delivery-agents",
  getDeliveryAgentFilterLink: "/admin/deliveryagent-filters",
  getDeliveryAgentByIdLink: "/admin/delivery-agents",
  deleteDeliveryAgentLink: "/admin/delivery-agents",
  deliveryAgentOrderSats: "/admin/deliveryagent-orderstats",
  getActiveDeliveryAgents: "/admin/active-open-deliveryagents",
  deliveryAgentPayouts: "/admin/deliveryagent-payouts",
  deliveryAgentPaymentUpdate: "/admin/deliveryagent-payment-upd",

  // User Reprsentative Agent
  addUserRepresentativeLink: "/admin/add-userrep",
  editUserRepresentativeLink: "/admin/edit-userrep",
  getUserRepresentativeLink: "/admin/user-reps",
  getUserRepresentativeFilterLink: "/admin/userrep-filters",
  getUserRepresentativeByIdLink: "/admin/user-rep",
  deleteUserRepresentativeLink: "/admin/user-rep",
  userRepCodeGenerate: "/admin/userrep-code",
  userRepOrderSats: "/admin/userrep-orderstats",
  userRepPayouts: "/admin/userrep-payouts",
  userRepPaymentUpdate: "/admin/userrep-payment-upd",

  // Service Provider
  addServiceProviderLink: "/admin/add-serviceprovider",
  editServiceProviderLink: "/admin/edit-serviceprovider",
  getServiceProviderLink: "/admin/serviceproviders",
  getServiceProviderFilterLink: "/admin/serviceprovider-filters",
  getServiceProviderByIdLink: "/admin/serviceprovider",
  deleteServiceProviderLink: "/admin/delete-serviceprovider",
  getServiceProvidersByCategoryLink: "/admin/serviceproviders-by-category",
  getServiceBookingsLink: "/admin/service-bookings",
  getServiceBookingByIdLink: "/admin/service-bookings",
  assignServiceProviderToBookingLink: "/admin/assign-service-provider",

  // Services
  addServiceLink: "/admin/add-service",
  editServiceLink: "/admin/edit-service",
  getServiceLink: "/admin/services",
  getServiceFilterLink: "/admin/service-filters",
  getServiceByIdLink: "/admin/service",
  deleteServiceLink: "/admin/delete-service",
  getServiceCategoriesLink: "/admin/categories-service",

  // Telecaller Agent
  addTelecallerLink: "/admin/add-telecaller",
  getTelecallersAPIHost: "/admin/telecallers",
  deleteTelecallerAPIHost: "/admin/delete-telecaller",
  getTelecallerByIdAPIHost: "/admin/telecaller/",
  editTelecallerAPI: "/admin/edit-telecaller",
  getTelecallerFiltersAPI: "/admin/telecaller-filters",

  // Orders Section
  getOrdersLink: "/admin/orders",
  getOrdersFilterLink: "/admin/order-filters",
  getOrderByIdLink: "/admin/order",
  getRetailerOrdersLink: "/admin/retailer-orders",
  getRetailerOrdersFilterLink: "/admin/retailer-order-filters",
  getRetailerOrderIdLink: "/admin/retailer-order",
  updateRetailerOrderLink: "/admin/retailer-order-update",
  getSupplierLink: "/admin/suppliers",
  getSupplierFilterLink: "/admin/supplier-filters",
  getSupplierByIdLink: "/admin/supplier",
  addSupplierLink: "/admin/add-supplier",
  editSupplierLink: "/admin/edit-supplier",
  getSupplierAgreementLink: "/admin/supplier-agreements",
  getSupplierAgreementFilterLink: "/admin/supplier-agreement-filters",
  getSupplierAgreementByIdLink: "/admin/supplier-agreement",
  addSupplierAgreementLink: "/admin/add-supplier-agreement",
  editSupplierAgreementLink: "/admin/edit-supplier-agreement",
  getSupplierOrderLink: "/admin/supplier-orders",
  getSupplierOrderFilterLink: "/admin/supplier-order-filters",
  getSupplierOrderByIdLink: "/admin/supplier-order",
  updateSupplierOrderLink: "/admin/supplier-order",
  generateSupplierInvoiceLink: "/admin/supplier-order",
  getSupplierInvoiceLink: "/admin/supplier-invoices",
  getSupplierInvoiceFilterLink: "/admin/supplier-invoice-filters",
  getSupplierInvoiceByIdLink: "/admin/supplier-invoice",
  getSupplierCreditNoteLink: "/admin/supplier-credit-notes",
  getSupplierCreditNoteFilterLink: "/admin/supplier-credit-note-filters",
  getSupplierCreditNoteByIdLink: "/admin/supplier-credit-note",
  addSupplierCreditNoteLink: "/admin/add-supplier-credit-note",
  getSupplierSettlementLink: "/admin/supplier-settlements",
  getSupplierSettlementFilterLink: "/admin/supplier-settlement-filters",
  getSupplierSettlementByIdLink: "/admin/supplier-settlement",
  addSupplierSettlementLink: "/admin/add-supplier-settlement",
  editSupplierSettlementLink: "/admin/edit-supplier-settlement",
  getRetailerByZone: "/admin/retailers-list",
  reAssignOrderAgent: "/admin/reassign-order",
  plCheckStatus: "/admin/pl-check-status",
  regenratePL: "/admin/regenerate-pl",
  refundInitiate: "/admin/refunds/initiate",
  refundCheckStatus: "/admin/refunds/check-status",
  createReplacement: "/admin/create-replacement",
  cancelReplacement: "/admin/cancel-replacement",
  attachOrderEvidence: "/admin/attach-order-evidences",

  // Payment Section
  getPaymentsLink: "/admin/payments",
  getPaymentsFilterLink: "/admin/payments-filters",
  getPaymentByIdLink: "/admin/payment",

  // Coupon Section
  addCouponLink: "/admin/add-coupon",
  editCouponLink: "/admin/edit-coupon",
  getCouponLink: "/admin/coupons",
  getCouponFilterLink: "/admin/coupon-filters",
  getCouponByIdLink: "/admin/coupon",
  deleteCouponLink: "/admin/delete-coupon",

  // Fee Section
  addFeeLink: "/admin/add-fee",
  editFeeLink: "/admin/edit-fee",
  getFeeLink: "/admin/fees",
  getFeeFilterLink: "/admin/fee-filters",
  getFeeByIdLink: "/admin/fee",
  deleteFeeLink: "/admin/delete-fee",

  // IncentiveRule Section

  addIncentiveRuleLink: "/admin/add-incentiverule",
  editIncentiveRuleLink: "/admin/edit-incentiverule",
  getIncentiveRuleLink: "/admin/incentiverules",
  getIncentiveRuleFilterLink: "/admin/incentiverule-filters",
  getIncentiveRuleByIdLink: "/admin/incentiverule",
  deleteIncentiveRuleLink: "/admin/delete-incentiverule",

  // Validation

  userPhoneValidation: "/admin/phone-validation",

  // Users
  // addUsersLink: '/admin/add-user',
  // editUsersLink: '/admin/edit-user',
  getUsersLink: "/admin/users",
  getUsersFilterLink: "/admin/user-filters",
  getUsersByIdLink: "/admin/user",
  // deleteUsersLink:'/admin/user',

  bulkUploadProductsAPI: "/admin/bulk/imports",
  getBulkUploadDetailsByIdLink: "/admin/bulk/imports",
  bulkUploadXLSX: "/admin/bulk/upload-xlsx",

  // Dashboard
  dashboardSummaryAPI: "/db/admin/dashboard/summary",
  dashboardTrendsAPI: "/db/admin/orders/trend",
  dashboardOrdersBreakdownAPI: "/db/admin/orders/breakdown",
  dashboarPaymentSummaryAPI: "/db/admin/payments/summary",
  deliveryPerformanceAPI: "/db/admin/delivery/performance",
  deliveryAlertsAPI: "/db/admin/inventory/alerts",

  // Panchangam Calendar
  getPanchangamCalendarAPI: "/admin/panchangam-calendar",
  savePanchangamCalendarAPI: "/admin/panchangam-calendar",

  // Devotional Library
  devotionalLibraryConfigAPI: "/admin/devotional-library/config",
  devotionalLibraryDashboardAPI: "/admin/devotional-library/dashboard",
  comicSeriesFiltersAPI: "/admin/devotional-library/comic-series/filters",
  comicSeriesListAPI: "/admin/devotional-library/comic-series/list",
  comicSeriesAPI: "/admin/devotional-library/comic-series",
  comicEpisodeFiltersAPI: "/admin/devotional-library/comic-series/{seriesId}/episodes/filters",
  comicEpisodeListAPI: "/admin/devotional-library/comic-series/{seriesId}/episodes/list",
  comicEpisodeAPI: "/admin/devotional-library/comic-series/{seriesId}/episodes",
  bookFiltersAPI: "/admin/devotional-library/books/filters",
  bookListAPI: "/admin/devotional-library/books/list",
  booksAPI: "/admin/devotional-library/books",
  stotramFiltersAPI: "/admin/devotional-library/stotrams/filters",
  stotramListAPI: "/admin/devotional-library/stotrams/list",
  stotramsAPI: "/admin/devotional-library/stotrams",
  deityGroupFiltersAPI: "/admin/devotional-library/deity-groups/filters",
  deityGroupListAPI: "/admin/devotional-library/deity-groups/list",
  deityGroupsAPI: "/admin/devotional-library/deity-groups",

  // Devotional Events
  devotionalEventsConfigAPI: "/admin/devotional-events/config",
  devotionalEventsDashboardAPI: "/admin/devotional-events/dashboard",
  devotionalEventTypesListAPI: "/admin/devotional-events/types/list",
  devotionalEventTypesAPI: "/admin/devotional-events/types",
  devotionalEventOrganizersListAPI: "/admin/devotional-events/organizers/list",
  devotionalEventOrganizersAPI: "/admin/devotional-events/organizers",
  devotionalEventValidatorsListAPI: "/admin/devotional-events/validators/list",
  devotionalEventValidatorsAPI: "/admin/devotional-events/validators",
  devotionalEventsListAPI: "/admin/devotional-events/list",
  devotionalEventsAPI: "/admin/devotional-events",
  devotionalEventBookingsListAPI: "/admin/devotional-events/bookings/list",
  devotionalEventBookingsAPI: "/admin/devotional-events/bookings",
  devotionalEventInvoicesListAPI: "/admin/devotional-events/invoices/list",
  devotionalEventInvoicesAPI: "/admin/devotional-events/invoices",

  // Temples
  templeConfigAPI: "/admin/temples/config",
  templeDashboardAPI: "/admin/temples/dashboard",
  templesListAPI: "/admin/temples/list",
  templesAPI: "/admin/temples",
  templePoojasListAPI: "/admin/temple-poojas/list",
  templePoojasAPI: "/admin/temple-poojas",
  templeEventsListAPI: "/admin/temple-events/list",
  templeEventsAPI: "/admin/temple-events",
  templeBookingsListAPI: "/admin/temple-bookings/list",
  templeBookingsAPI: "/admin/temple-bookings",
  templeTicketsListAPI: "/admin/temple-tickets/list",
  templeTicketsAPI: "/admin/temple-tickets",

  // Event Organizer
  eventAdminConfigAPI: "/eventadmin/devotional-events/config",
  eventAdminOrganizerProfileAPI: "/eventadmin/devotional-events/organizer/me",
  eventAdminEventsListAPI: "/eventadmin/devotional-events/list",
  eventAdminEventsAPI: "/eventadmin/devotional-events",
  eventAdminValidatorsListAPI: "/eventadmin/ticket-validators/list",
  eventAdminValidatorsAPI: "/eventadmin/ticket-validators",
  eventAdminBookingsListAPI: "/eventadmin/devotional-events/{eventId}/bookings",
  eventAdminBookingsAPI: "/eventadmin/devotional-events/bookings",
  eventAdminInvoicesListAPI: "/eventadmin/devotional-events/invoices/list",
  eventAdminInvoicesAPI: "/eventadmin/devotional-events/invoices",

  // Temple Admin
  templeAdminConfigAPI: "/templeadmin/temples/config",
  templeAdminProfileAPI: "/templeadmin/temples/me",
  templeAdminPoojasListAPI: "/templeadmin/temple-poojas/list",
  templeAdminPoojasAPI: "/templeadmin/temple-poojas",
  templeAdminEventsListAPI: "/templeadmin/temple-events/list",
  templeAdminEventsAPI: "/templeadmin/temple-events",
  templeAdminValidatorsListAPI: "/templeadmin/ticket-validators/list",
  templeAdminValidatorsAPI: "/templeadmin/ticket-validators",
  templeAdminBookingsListAPI: "/templeadmin/temple-bookings/list",
  templeAdminBookingsAPI: "/templeadmin/temple-bookings",
  templeAdminTicketsListAPI: "/templeadmin/temple-tickets/list",
  templeAdminTicketsAPI: "/templeadmin/temple-tickets",

  // Subscriptions
  subscriptionConfigAPI: "/admin/subscriptions/config",
  subscriptionDashboardAPI: "/admin/subscriptions/dashboard",
  subscriptionTiersListAPI: "/admin/subscriptions/tiers/list",
  subscriptionTiersAPI: "/admin/subscriptions/tiers",
  subscriptionPlansListAPI: "/admin/subscriptions/plans/list",
  subscriptionPlansAPI: "/admin/subscriptions/plans",
  subscriptionBenefitRulesListAPI: "/admin/subscriptions/benefit-rules/list",
  subscriptionBenefitRulesAPI: "/admin/subscriptions/benefit-rules",
  subscriptionUsersListAPI: "/admin/subscriptions/users/list",
};



